module.exports = __webpack_public_path__ + "static/media/gift-list4.bdf25e46.png";